import React from 'react';
import {Link} from 'react-router-dom';
import {Ava} from './Ava';

export class About extends React.Component {
  render () {
    return (
      <div className="content fading about">
        <div className="article">
          <div className="back">
            <span id="wavy-back" className="about"></span>
            <div className="salut about">
              <Ava />
            </div>
            <div className="art-title">Hello :)</div>
            <div className="text">
              <p>My name is Olesia Lozovska.</p>
              <br></br>
              <p>I'm one of those crazy moms that want to do something special for their children, that is how <b>BeBiBoo</b> started. I was truly inspired by my beautiful son, sewing the first book and he continues inspire me every day.</p>
            </div>
          </div>
          <div className="decor-line">
            <div className="color1"></div>
            <div className="color2"></div>
            <div className="color3"></div>
            <div className="color4"></div>
            <div className="color5"></div>
            <div className="color6"></div>
          </div>
          <div className="decor-img"></div>
          <div className="text-2">
            <p>Actualy I'm a teacher by education and I love sewing and adore kids - I believe that it helps me to design not only nice and cute, but also educative books that help to develop fine motor skills of small cute fingers that will play with the book.</p>
            <br></br>
            <p>So thank you for visiting my site and for your interest. I'll apreciate any feedback, just <Link to='/Contact'><b>send me a message</b></Link>.</p>
            <br></br>
            <p>Please feel free to come up with your own ideas for the pages or book topic - I will be happy to implement them in your next best personalized textile book for your world best child.</p>
          </div>
        </div>
      </div>
    )
  }
}


export default About;



// WEBPACK FOOTER //
// ./src/components/__About.js